/**
 * Manage download products
 */
document.addEventListener('DOMContentLoaded', function () {
    const otherDownloadBtns = document.querySelectorAll('.other-downloads');

    otherDownloadBtns.forEach(btn => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            const otherVersions = btn.closest('.other-download-versions');
            const selectOption = otherVersions.querySelector('select option:checked')
            const downloadUrl = selectOption.getAttribute('data-download-url');

            // Create a hidden anchor element
            const link = document.createElement('a');
            link.style.display = 'none';
            document.body.appendChild(link);

            // Set the download URL and trigger the click event
            link.href = downloadUrl;
            link.click();
            // Remove the anchor element
            document.body.removeChild(link);

        })
    });
})